module.exports = __webpack_public_path__ + "static/ChristianAvendano-9c908fc49dbe571a83cc61829a87e5d9.jpg";